import React, { useState } from 'react';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';

const CurlGenerator = ({ endpoint, method = 'POST', headers = [], fields = [], bodyTemplate }) => {
  // Initialize state for each field
  const initialState = {};
  fields.forEach(f => {
    initialState[f.name] = f.default || '';
  });
  const [form, setForm] = useState(initialState);
  const [copied, setCopied] = useState(false);

  const handleChange = (e, name) => {
    setForm({ ...form, [name]: e.target.value });
  };

  // Build headers string
  const headerStr = headers
    .map(h => `-H "${h.label}: ${h.value.replace(/\{(.*?)\}/g, (_, key) => form[key] || '')}" \\`)
    .join('\n  ');

  // Build body string
  let bodyStr = '';
  if (bodyTemplate) {
    bodyStr = bodyTemplate(form);
  } else {
    // fallback: JSON.stringify all fields
    bodyStr = JSON.stringify(form, null, 2);
  }

  // Build cURL command
  const curl = `curl -X ${method} ${endpoint} \
  ${headerStr}
  -H "Content-Type: application/json" \
  -d '${bodyStr}'`;

  const handleCopy = () => {
    navigator.clipboard.writeText(curl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white rounded shadow p-4 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {fields.map(field => (
          <div key={field.name}>
            <label className="block text-xs font-semibold text-gray-700 mb-1">
              {field.label || field.name}{field.required && <span className="text-red-500">*</span>}
            </label>
            <input
              value={form[field.name]}
              onChange={e => handleChange(e, field.name)}
              className="w-full border rounded px-2 py-1 text-sm"
              type={field.type || 'text'}
              placeholder={field.placeholder || ''}
            />
          </div>
        ))}
      </div>
      <div className="relative">
        <pre className="bg-gray-800 text-gray-100 rounded p-3 text-xs overflow-x-auto whitespace-pre-wrap">
          {curl}
        </pre>
        <button
          onClick={handleCopy}
          className="absolute top-2 right-2 p-1 rounded hover:bg-gray-700 text-gray-300 hover:text-white focus:outline-none"
          title="Copy cURL command"
        >
          <ClipboardDocumentIcon className="h-5 w-5 inline" />
          {copied && <span className="ml-2 text-xs text-green-400">Copied!</span>}
        </button>
      </div>
    </div>
  );
};

export default CurlGenerator; 